export default __webpack_public_path__ + "static/media/check_f.9ecace16.svg";